<div class="role-request list-page">
    <lokos-page-header [label]="'Role Request'" [breadcrumbs]="breadcrumbs()" />

    <div class="list-page-filters">
        @if (form.get('isApplication')?.value === 'Yes') {
            <div
                fxFlex.gt-sm="31"
                fxFlex.gt-xs="48"
                fxFlex="100"
                fxFlex.gt-md="31"
            >
                <lokos-select
                    [label]="'applicationList'"
                    [placeholder]="'applicationList'"
                    [optionsList]="applicationList"
                    [required]="false"
                    [control]="$any(form.get('application'))"
                    [displayName]="'description'"
                ></lokos-select>
            </div>
        }

        @if (form.get('isApplication')?.value === 'No') {
            <div
                fxFlex.gt-sm="31"
                fxFlex.gt-xs="48"
                fxFlex="100"
                fxFlex.gt-md="31"
            >
                <lokos-select
                    [label]="'stateName'"
                    [placeholder]="'stateName'"
                    [optionsList]="stateList"
                    [required]="false"
                    [control]="$any(form.get('stateId'))"
                    [getName]="'state_id'"
                    [displayName]="'state_name_en'"
                ></lokos-select>
            </div>
            <div
                fxFlex.gt-sm="31"
                fxFlex.gt-xs="48"
                fxFlex="100"
                fxFlex.gt-md="31"
            >
                <lokos-select
                    [label]="'districtName'"
                    [placeholder]="'districtName'"
                    [optionsList]="districtList"
                    [required]="false"
                    [control]="$any(form.get('districtId'))"
                    [getName]="'district_id'"
                    [displayName]="'district_name_en'"
                ></lokos-select>
            </div>
            <div
                fxFlex.gt-sm="31"
                fxFlex.gt-xs="48"
                fxFlex="100"
                fxFlex.gt-md="31"
            >
                <lokos-select
                    [label]="'blockName'"
                    [placeholder]="'blockName'"
                    [optionsList]="blockList"
                    [required]="false"
                    [control]="$any(form.get('blockId'))"
                    [getName]="'block_id'"
                    [displayName]="'block_name_en'"
                ></lokos-select>
            </div>
        }
        <div fxFlex.gt-sm="31" fxFlex.gt-xs="48" fxFlex="100" fxFlex.gt-md="31">
            <lokos-select
                [label]="'roleName'"
                [placeholder]="'roleName'"
                [optionsList]="keyClockRoles"
                [required]="true"
                [control]="$any(form.get('role'))"
                [displayName]="'description'"
            ></lokos-select>
        </div>
        <div
            fxFlex.gt-sm="100"
            fxFlex.gt-xs="100"
            fxFlex="100"
            fxFlex.gt-md="100"
        >
            <lokos-button
                [label]="'request'"
                [type]="'primary'"
                (afterClick)="onSubmitRequest()"
            ></lokos-button>
        </div>
    </div>

    <div class="list-page-table">
        <lokos-table
            [columns]="columns()"
            [tableRecord]="dataSource()"
            [entity]="'user_profile'"
        />
        <lokos-pagination
            [maxSize]="5"
            [rotate]="true"
            [collectionSize]="totalElement()"
            [pageSize]="pageSize()"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onPageSizeChange($event)"
        />
    </div>
</div>
